/**
 * @fileoverview POST handler for the "/apps/catalogs/:catalog_id/export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogsCatalogIdExportCacheKeys } from "./constants";
import type { PostAppsCatalogsCatalogIdExportProps, AppsCatalogsCatalogIdExportResult } from "./types";

export const postAppsCatalogsCatalogIdExport = reactQueryMutationAdapter(
  appsCatalogsCatalogIdExportCacheKeys,
  (props: PostAppsCatalogsCatalogIdExportProps): Promise<AppsCatalogsCatalogIdExportResult> => {
    // manipulate props here as needed {  }

    return fetch(`/apps/catalogs/${props.catalogId}/export`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
